export default __webpack_public_path__ + "static/media/wotatoch-genet-school.5adeb859.jpg";